import { virtualElements, domData } from '@tko/utils'

import { unwrap } from '@tko/observable'

import { IfBindingHandler } from './ifUnless'

/**
 * The `else` binding
 * (not to be mistaken for `<!-- else -->` inside if bindings.
 */
export class ElseBindingHandler extends IfBindingHandler {
  _elseChain: any

  override shouldDisplayIf() {
    return super.shouldDisplayIf() || this.value === undefined
  }

  /**
   * Return any conditional that precedes the given node.
   * @return {object}      { elseChainSatisfied: observable }
   */
  override get elseChainIsAlreadySatisfied() {
    if (!this._elseChain) {
      this._elseChain = this.readElseChain()
    }
    return unwrap(this._elseChain.elseChainSatisfied)
  }

  readElseChain() {
    let node: ChildNode | null = this.$element
    do {
      node = node.previousSibling
    } while (node && node.nodeType !== Node.ELEMENT_NODE && node.nodeType !== Node.COMMENT_NODE)

    if (!node) {
      return false
    }

    if (node.nodeType === Node.COMMENT_NODE) {
      node = virtualElements.previousSibling(node)
    }

    return domData.get(node as Node, 'conditional') || {}
  }
}
